import axiosInstance from '../../shared/utils/axios';

const getContext = session => {
  let con = {};
  let op;
  switch (session.profile.role) {
    case 'ADVISOR':
      con.type = 'ADVISOR';
      con.name = 'My Portfolio';
      con.id = session.profile.id;
      op = axiosInstance.get(`/advisors/${session.profile.id}/containers`)
        .then(res => res.data.find(c => c.type === 'ADVISOR' && c.highLevel === 'ASSETS'));
      break;
    case 'BRANCHMGR':
      con.type = 'BRANCH';
      op = axiosInstance.get('/branches')
        .then(res => {
          const branch = res.data[0];
          if (!branch) {
            return {};
          }
          con.name = branch.name;
          con.id = branch.id;
          return axiosInstance.get(`/branches/${branch.id}/containers`);
        })
        .then(res => res.data.find(c => c.type === 'BRANCH' && c.highLevel === 'ASSETS'));
      break;
    case 'FIRMMGR':
    case 'CPLO':
      con.type = 'FIRM';
      con.name = 'Firm View';
      con.id = session.profile.firm.id;
      op = axiosInstance.get(`/firms/${session.profile.firm.id}/containers`)
        .then(res => res.data.find(c => c.type === 'FIRM' && c.highLevel === 'ASSETS'));
      break;
    default:
      // ETODO Better error handling
      return null;
  }
  return op
    .then(container => ({
      containerID: container.id,
      ...con,
    }));
};

export default getContext;
